module.exports = __webpack_public_path__ + "img/group-chat.6f70e6d1.svg";